import React, { FC, useRef, useState } from 'react';
import { DriverReportFilter } from '../Filter';
import data from './data.json';
import { Table, Button } from 'react-bootstrap';
import GeneratePDF from '../_common/GeneratePDF/GeneratePDF';
import { useReactToPrint } from 'react-to-print';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import './DriverReport.scss';
import { GET_LOADS_CSV } from '../../graphql/client/queries';
import { useQuery } from '@apollo/client/react';
import type { GetLoadListCSV } from '../../types/schemaTypes';
import { Base64 } from 'js-base64';
import 'jspdf-autotable';
const DriverReport: FC = (): React.ReactElement => {
    const [listHeight, setListHeight] = useState(window.screen.height);
    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = 'SBS';
    const jobId = 1;
    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
        contentRef: componentRef,
    });
    const { data: csvExport } = useQuery<GetLoadListCSV>(GET_LOADS_CSV, {
        variables: {
            input: {
                jobId,
            },
        },
    });
    const getCurrentDate = (): string => {
        const today = new Date();

        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();

        const strDay = day < 10 ? `0${day}` : `${day}`;
        const strMonth = month < 10 ? `0${month}` : `${month}`;

        return `${year}${strMonth}${strDay}`;
    };
    const exportCsv = (): void => {
        if (csvExport?.getLoadListCSV?.csv) {
            const decodedCsv = Base64.decode(csvExport.getLoadListCSV.csv ?? '');

            const file = new Blob([decodedCsv], { type: 'application/csv' });
            const url = window.URL.createObjectURL(file);
            const a = document.createElement('a');
            a.href = url;

            a.download = `List of Loads_${getCurrentDate()}.csv`;
            a.click();
        }
    };
    class ComponentToPrint extends React.Component<{ innerRef: React.RefObject<HTMLDivElement | null> }> {
        public render() {
            const { innerRef } = this.props;
            return (
                <div ref={innerRef}>
                <Table striped bordered hover className="printtest">
                    <thead>
                        <tr>
                            {Object.keys(data[0]).map(i => (
                                <th key={i}>{i}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: teams">
                        {data.map(i => (
                            <tr key={i['regionId']}>
                                {Object.keys(i).map(f => (
                                    <td key={f}>{i[f]}</td>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </div>
            );
        }
    }
    return (
        <div className="LoadManagement-Container">
            <div className="">
                <div id="loadsFilterContainer" className="ReportFilter-Filter">
                    <DriverReportFilter />
                </div>
                <div id="optionsContainer" className="ReportFilter-Filter">
                    <Row>
                        <Col md={4}>
                            <GeneratePDF data={data} />
                        </Col>
                        <Col md={4}>
                            <button onClick={handlePrint} className={`CustomButton-Default ${'CustomButton-Plain'} `}>
                                Print
                            </button>
                        </Col>
                        <Col md={4}>
                            <button className={`CustomButton-Default ${'CustomButton-Plain'} `} onClick={exportCsv}>
                                CSV
                            </button>
                        </Col>
                    </Row>
                </div>
                <div id="loadsListContainer" className="LoadManagement-List">
                    <div style={{ display: 'none' }} className="printdiv">
                        <ComponentToPrint innerRef={componentRef} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DriverReport;

